var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { ErrorMessageBox, FallbackComponent, FormField } from '../common';
import { useDuplicatePlanAPI, usePlansAPI } from './selectors';
export var DuplicatePlanDialog = function (_a) {
  var _b, _c, _d;
  var open = _a.open,
    onClose = _a.onClose,
    plan = _a.plan,
    resetTableState = _a.resetTableState;
  var t = useTranslation(['myPlans', 'translation']).t;
  var _e = usePlansAPI(),
    fetchPlans = _e[1];
  var _f = useDuplicatePlanAPI(),
    duplicatePlanData = _f[0],
    duplicatePlan = _f[1],
    clearDuplicatePlanData = _f[2];
  var copyOfLabel = t('copyOf');
  var defaultValues = useMemo(function () {
    var _a;
    return {
      basePlanId: (_a = plan === null || plan === void 0 ? void 0 : plan.basePlanId) !== null && _a !== void 0 ? _a : 0,
      name: "".concat(copyOfLabel, " ").concat(plan === null || plan === void 0 ? void 0 : plan.name)
    };
  }, [copyOfLabel, plan === null || plan === void 0 ? void 0 : plan.basePlanId, plan === null || plan === void 0 ? void 0 : plan.name]);
  var validateForm = yup.object().shape({
    name: yup.string().required().max(128).normalizeSpace().specialCharacter().quotesNotAllowed().label('Name')
  });
  var _g = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(validateForm)
    }),
    control = _g.control,
    handleSubmit = _g.handleSubmit,
    reset = _g.reset;
  useEffect(function () {
    if (open) {
      reset(defaultValues);
      return clearDuplicatePlanData;
    }
  }, [open, reset, clearDuplicatePlanData, defaultValues]);
  useEffect(function () {
    var _a, _b;
    if (((_b = (_a = duplicatePlanData.data) === null || _a === void 0 ? void 0 : _a.actualCopyOperation) === null || _b === void 0 ? void 0 : _b.status) === 'completed') {
      onClose();
      fetchPlans();
      resetTableState();
    }
  }, [duplicatePlanData.data, fetchPlans, onClose, resetTableState]);
  var copyError = ((_c = (_b = duplicatePlanData.data) === null || _b === void 0 ? void 0 : _b.actualCopyOperation) === null || _c === void 0 ? void 0 : _c.status) === 'failed' ? [{
    message: (_d = duplicatePlanData.data.actualCopyOperation.errorMessage) !== null && _d !== void 0 ? _d : t('actualCopyFailed')
  }] : [];
  return _jsx(Dialog, __assign({
    open: open,
    onClose: onClose
  }, {
    children: _jsxs(Box, __assign({
      component: "form",
      onSubmit: handleSubmit(function (values) {
        return duplicatePlan(values);
      })
    }, {
      children: [_jsx(DialogTitle, __assign({
        variant: "h2"
      }, {
        children: t('duplicatePlanTitle')
      })), _jsx(DialogContent, {
        children: _jsxs(FallbackComponent, __assign({
          requesting: !!duplicatePlanData.requesting,
          overlay: true
        }, {
          children: [_jsx(ErrorMessageBox, {
            errors: __spreadArray(__spreadArray([], copyError, true), [duplicatePlanData.error], false)
          }), _jsx(FormField, __assign({
            required: true,
            name: "name",
            label: t('planName'),
            control: control
          }, {
            children: _jsx(TextField, {
              inputProps: {
                maxLength: 128
              }
            })
          }))]
        }))
      }), _jsxs(DialogActions, __assign({
        sx: {
          justifyContent: 'space-between'
        }
      }, {
        children: [_jsx(Button, __assign({
          variant: "outlined",
          onClick: onClose
        }, {
          children: t('translation:action.cancel')
        })), _jsx(Button, __assign({
          variant: "contained",
          type: "submit",
          disabled: duplicatePlanData.requesting
        }, {
          children: t('translation:action.save')
        }))]
      }))]
    }))
  }));
};